module.exports = __webpack_public_path__ + "static/img/motor_64.288845b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/motor_64.png
// module id = ++tU
// module chunks = 0